import { utils, writeFile } from 'xlsx'
const objToXlsx = (data, fileName = 'file') => {
    data = Array.isArray(data) ? data : [data]
    try {
        let wb = utils.book_new(),
            ws = utils.json_to_sheet(data);
        utils.book_append_sheet(wb, ws, `${fileName}`)
        writeFile(wb, `${fileName}.csv`)
    } catch (error) {
        console.error(error);
    }
}
export default objToXlsx